import { render, staticRenderFns } from "./PoaConfig.vue?vue&type=template&id=2552c287"
import script from "./PoaConfig.vue?vue&type=script&lang=js"
export * from "./PoaConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports